
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import { EnumMyAccountExchange } from '@xt/client/enums/my'
import ExchangeList from './views/List/index.vue'
import ExchangeDetail from './views/Detail/index.vue'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {
    ExchangeList,
    ExchangeDetail
  }
})
export default class MyAccountExchange extends Vue {
  current: string = EnumMyAccountExchange.List
  productId: number = 0

  compMap: Record<EnumMyAccountExchange.List | EnumMyAccountExchange.Detail, string> = {
    [EnumMyAccountExchange.List]: 'ExchangeList',
    [EnumMyAccountExchange.Detail]: 'ExchangeDetail'
  }

  get EnumMyAccountExchange() {
    return EnumMyAccountExchange
  }

  get currentComp(): string {
    return this.compMap[this.current]
  }

  handleToDetail(id: number) {
    this.productId = id
    this.handleCurrentChange(EnumMyAccountExchange.Detail)
  }

  handleCurrentChange(current: EnumMyAccountExchange.List | EnumMyAccountExchange.Detail) {
    this.current = current

    document.documentElement.scrollTo({ top: 0 })
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
